export default __webpack_public_path__ + "static/media/SB4.aa0a7377.jpg";